export const NO_DATA_FOUND_LABEL = 'No data found.';
export const SEARCH_PLACEHOLDER = 'Search by name...';
export const ON_SITE_REGISTRATION_PLAYERS_DATA_SOURCE = 'players';
export const ON_SITE_REGISTRATION_CADDIES_DATA_SOURCE = 'caddies';
